var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.getMargin()),attrs:{"id":"stories"}},_vm._l((_vm.stories),function(story,index){return _c('Story',{key:index,ref:"stories",refInFor:true,attrs:{"slideDuration":_vm.slideDuration,"slides":story}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }